import script from "./Detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./Detail.vue?vue&type=script&setup=true&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=ab109c1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab109c1a"]])

export default __exports__